import { Drawer } from '@mantine/core';
import { useLayoutStore } from '../../stores/layoutStore';
import { layout } from '../../theme/layout';

interface SidebarDrawerProps {
  /** Drawerに表示するサイドバーコンテンツ */
  children: React.ReactNode;
}

/**
 * サイドバーDrawerコンポーネント
 *
 * md以下の画面幅でサイドバーをDrawer形式で表示する。
 * useLayoutStoreと連携してdrawerOpen状態で開閉制御を行う。
 *
 * @example
 * ```tsx
 * <SidebarDrawer>
 *   <LeftPanel {...props} />
 * </SidebarDrawer>
 * ```
 */
export function SidebarDrawer({ children }: SidebarDrawerProps) {
  const { drawerOpen, closeDrawer } = useLayoutStore();

  return (
    <Drawer
      opened={drawerOpen}
      onClose={closeDrawer}
      position="left"
      size={layout.sidebar.width}
      withCloseButton={false}
      overlayProps={{ backgroundOpacity: 0.5, blur: 2 }}
      styles={{
        body: {
          padding: 0,
          height: '100%',
        },
        content: {
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {children}
    </Drawer>
  );
}
